import { Box, Divider, IconButton, Stack, Typography } from "@mui/material";
import "./drawermandate.scss";
import moment from "moment";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import SettingsIcon from "@mui/icons-material/Settings";

import { SearchTextField } from "../../Utils/Component";
import { useGetMandatePagination } from "../../Hooks/useGetMandatePagination";
import { AuthContext } from "../../Context/AuthContext";
import { useContext } from "react";
import { getKhmerNumber } from "../../Function/DynamicFn";

const getMandateId = () => {
  return window.localStorage.getItem("mandate_id") || "";
};

const removeMandateId = () => {
  window.localStorage.removeItem("mandate_id");
  window.location.reload();
};

export default function DrawerMandate({ toggleDrawer }) {
  const { t, language } = useContext(AuthContext);

  const mandateId = getMandateId();
  const handleGoToMandate = (id) => {
    window.localStorage.setItem("mandate_id", id);
    window.location.reload();
  };

  const { tableData, handleSearch } = useGetMandatePagination();
  const level = language === "kh" ? "ទី" : "";

  return (
    <Box className="drawer-mandate-container">
      <Stack
        sx={{ width: "100%" }}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography className="title">{t("thead_switch_mandate")}</Typography>
        <IconButton onClick={toggleDrawer(false)}>
          <CloseIcon sx={{ color: "red" }} />
        </IconButton>
      </Stack>
      <Divider />
      <Box sx={{ paddingY: 2 }}>
        <SearchTextField className={"text-field"} handleSearch={handleSearch} />
      </Box>
      <Stack>
        <Stack
          sx={{ width: "100%" }}
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
        >
          <Stack
            direction="row"
            spacing={0.5}
            alignItems="center"
            className="box-manage"
            onClick={removeMandateId}
          >
            <SettingsIcon className="icon-manage" />
            <Typography className="manage">{t("thead_manage")}</Typography>
          </Stack>
        </Stack>

        {tableData?.map((row, index) => {
          const mandate =
            language === "kh"
              ? getKhmerNumber(parseFloat(row?.mandateName))
              : row?.mandateName;
          return (
            <Box
              key={index}
              className={
                mandateId === row?._id ? "item-mandate-active" : "item-mandate"
              }
              onClick={() => handleGoToMandate(row?._id)}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Stack direction="column" spacing={0.5}>
                  <Typography className="mandate-name">
                    {t("thead_mandate") + level + mandate || ""}
                  </Typography>
                  <Typography className="mandate-date">
                    On Date : {moment().format("DD-MM-YYYY")}
                  </Typography>
                </Stack>

                <DoneIcon className="icon" />
              </Stack>
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
}
